module.exports = __webpack_public_path__ + "img/workday.f467277f.svg";